import React, { useEffect, useState } from "react";
import { DriverBasicDetailsContainer } from "../../../constants/assets/DriverDetailsContainers";
import { useHistory, useParams } from "react-router-dom";
import { connect } from "react-redux";
import Dispute from "./Dispute";
import MetaData from "./MetaData";
import { getPath } from "../../../utils";
import HorizontalTabs from "sushiweb/HorizontalTabs";

const TabBasic = {
    name: "Basic",
    url: "",
};
const TabMetadata = {
    name: "MetaData",
    url: "metadata",
};

const subTabs = [TabBasic, TabMetadata];

const Details = ({ details }) => {
    const history = useHistory();
    const { id, detailType } = useParams();
    const [curSubTab, setCurSubTab] = useState("");
    
    const findAndSeparateByID = (details, id) => {
        const dispute = details.find(d => d.id === id);
        if (!dispute) {
            return { basic: {}, metadata: {} };
        }

        const { metadata, ...otherdetails } = dispute;
        return {
            basic: otherdetails,
            metadata: metadata
        };
    };

    const getCurrentTabComponent = () => {
        switch (curSubTab) {
            case TabMetadata.url:
                return <MetaData data={findAndSeparateByID(details, id)} />;
            default:
                return <Dispute data={findAndSeparateByID(details, id)} />;
        }
    };

    useEffect(() => {
        setCurSubTab(detailType);
    }, [detailType]);

    return (
        <DriverBasicDetailsContainer>
            <HorizontalTabs id="sushi-tabs" className="mb-20" alignLinks="left">
                {subTabs.map((tab, index) => {
                    return (
                        <HorizontalTabs.Link
                            active={curSubTab == tab.url}
                            onClick={() => {
                                history.push(`/disputes/${id}/${tab.url}`);
                            }}
                            key={index}
                            className={`tab${index}${curSubTab === tab.url}`}
                        >
                            {tab.name}
                        </HorizontalTabs.Link>
                    );
                })}
            </HorizontalTabs>
            {getCurrentTabComponent()}
        </DriverBasicDetailsContainer>
    );
};

function mapStateToProps(state) {
    const { Disputes } = state;
    return {
        details: Disputes.Dispute,
    };
}

function mapDispatchToProps(dispatch) {
    return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(Details);
